import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { PrayersOptIn } from './PrayersOptIn';

const KEY = 'cfr_prayers_exit_seen';
const MIN_SECONDS = 30;

// Gentle, desktop-only, once per visitor, never before 30s on the page.
export const ExitIntentPrayers = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || window.innerWidth < 900 || localStorage.getItem(KEY)) return;
    if (localStorage.getItem('customer_token')) return; // already a member
    const start = Date.now();
    const onLeave = (e) => {
      if (e.clientY > 10 || Date.now() - start < MIN_SECONDS * 1000) return;
      localStorage.setItem(KEY, '1');
      setOpen(true);
      document.removeEventListener('mouseout', onLeave);
    };
    document.addEventListener('mouseout', onLeave);
    return () => document.removeEventListener('mouseout', onLeave);
  }, []);

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div key="bg" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(27,42,65,0.55)', zIndex: 9990, backdropFilter: 'blur(3px)' }} />
          <motion.div key="box" data-testid="exit-intent-prayers" initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 24 }} style={{ position: 'fixed', left: '1rem', right: '1rem', top: '8vh', margin: '0 auto', maxWidth: '560px', background: '#fff', borderRadius: '18px', padding: '2rem', zIndex: 9991, boxShadow: '0 30px 80px rgba(0,0,0,0.3)', maxHeight: '84vh', overflowY: 'auto' }}>
            <button data-testid="exit-intent-close" onClick={() => setOpen(false)} aria-label="Close" style={{ position: 'absolute', top: '0.9rem', right: '0.9rem', background: 'transparent', border: 0, cursor: 'pointer', color: '#6b6f66', width: 'auto', padding: '0.25rem' }}><X size={20} /></button>
            <p style={{ fontFamily: 'var(--font-heading)', fontSize: '1.5rem', color: '#1B2A41', margin: '0 0 0.25rem' }}>Before you go — seven prayers, free.</p>
            <p style={{ color: '#3d4a5c', margin: '0 0 1.25rem', lineHeight: 1.6 }}>For the nights you can't sleep and the days you've run out of words. No pressure, no follow-up you didn't ask for.</p>
            <PrayersOptIn variant="footer" source="exit_intent" />
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
